export const environment = {
  production: true,
  version: {
    major: '0',
    minor: '0',
    patch: '0',
  },
  build: {
    changeset: '937cb59',
  },
  apiBaseUrl: 'https://api.cloud.capawesome.io',
  consoleBaseUrl: 'https://console.cloud.capawesome.io',
  localStorageKeyPrefix: 'capawesome-cloud_',
};
